/* eslint-disable react/jsx-no-target-blank */
import type { FC } from 'react'
import React from 'react'
import { JOURNAL_TAG_ATTRIBUTES } from '@/constants/journal'
import { handleArticleLink } from '@/pages/JournalPublication/components/PublicationText/helpers'
import { messages } from '../messages'
import type { IPublicationComponentProps } from '../types'

const { readMore } = JOURNAL_TAG_ATTRIBUTES

export const PublicationReadMore: FC<IPublicationComponentProps> = props => {
  const { attribs } = props
  const articleLink = handleArticleLink(attribs[readMore.link])

  if (!articleLink) return null

  return (
    <div className={`focusBlock publicationText__readMore`}>
      <p className="text_body font-weight_light-bold">{messages.readMoreText}</p>
      <a href={articleLink} target="_blank">
        {attribs[readMore.anchor]}
      </a>
    </div>
  )
}
